import axios from 'axios'
import { BUSCAR_CUSTO_ITINERARIO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function buscarCustoItinerario (idItinerario) {
  const url = `${URL}/itinerario/${idItinerario}/custo-itinerario`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_CUSTO_ITINERARIO,
        payload: response

      })
  );
}
